export const RQPlanningKey = {
  planningHomeProducts: ['main', 'planning'] as const,
  planningPageProducts: ['planning'] as const,
};
